(function(){
  function getCartItems(el){ return el && el.closest ? el.closest('cart-items') : null; }
  document.addEventListener('click', function(event){
    var button = event.target.closest('.template-cart cart-items .quantity__button');
    if(!button) return;
    var quantity = button.closest('quantity-input');
    var input = quantity && quantity.querySelector('.quantity__input');
    var cartItems = getCartItems(button);
    if(!input || !cartItems || typeof cartItems.updateQuantity !== 'function') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var current = parseInt(input.value,10) || 0;
    var step = parseInt(input.step,10) || 1;
    var min = input.min !== '' ? parseInt(input.min,10) : 0;
    var max = input.max !== '' ? parseInt(input.max,10) : null;
    var next = button.name === 'plus' ? current + step : current - step;
    if(next < min) next = min;
    if(max !== null && next > max) next = max;
    if(next === current) return;
    input.value = next;
    cartItems.updateQuantity(input.dataset.index, next, button.name);
  }, true);
})();